import { render, staticRenderFns } from "./PropertyRequestLists.vue?vue&type=template&id=9044cdca&"
import script from "./PropertyRequestLists.vue?vue&type=script&lang=js&"
export * from "./PropertyRequestLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports